import React,{useState,useEffect} from "react";
import { getAWSUrl } from "../api/core";
import { RiTwitterXFill } from 'react-icons/ri';


import "./footer.css";

const Footer = (props) => {

  const [footer,setFooter]=useState('');
  const [footerData,setFooterData]=useState([]);
  const [footFirstSec,setFootFirstSec]=useState([]);
  const [footSecSec,setFootSecSec]=useState([]);
  const [footThirdSec,setFootThirdSec]=useState([]);

  useEffect(() => {

    setFooter(props.data);
    setFooterData(props.foot);
     const filterArray = (value) =>
     {
      const newArr = props.foot.items.filter(function (el) {
        return el.itemSection === value
      });
       return newArr;
     }
    
    if(props.foot.items.length>0)
    {
      setFootFirstSec(filterArray("First Section"));
      setFootSecSec(filterArray("Second Section"));
      setFootThirdSec(filterArray("Third Section"));
     
    }
   
  },[props.data,props.foot])

return(
    <div className="main-footer">
        <div className="container-fluid pad-left">
          <div className="row justify-content-lg-between justify-content-center">
            <div className="col-md-3">
              <div className="footer-widget">
                <div className="widget-content">
                  <div className="footer-logo"><img alt="" className="img-fluid" src={getAWSUrl()+footer} /></div>
                  <div className="footer-about-text">
                    <p className="text-muted">{footerData.footDescription}</p>
                  </div>
                  <div className="footer-social-icons">
                    <ul className="list-inline">
                      <li className="list-inline-item">
                        <a href={footerData.twitterLink} title="twitter"target="_blank">
                        <RiTwitterXFill style={{ fontSize: '24px' }} />      
                        </a>
                      </li>
                      {/* Social Icons Item 1 End */}
                      <li className="list-inline-item">
                        <a href={footerData.facebookLink} title="facebook"target="_blank"><i className="ri-facebook-fill" /></a>
                      </li>
                      {/* Social Icons Item 2 End */}
                      <li className="list-inline-item">
                        <a href={footerData.instagramLink} title="instagram"target="_blank"><i className="ri-instagram-line" /></a>
                      </li>
                      {/* Social Icons Item 3 End */}
                      <li className="list-inline-item">
                        <a href={footerData.youtubeLink} title="youtube"target="_blank"><i className="ri-youtube-fill" /></a>
                      </li>
                      {/* Social Icons Item 4 End */}
                    </ul>
                  </div>
                  {/* Social Icons End */}
                </div>
                {/* Footer Widget Content End */}
              </div>
              {/* Footer Widget End */}
            </div>
            {/* Col End */}
            <div className="col-md-3">
              <div className="footer-widget">
                <div className="widgets">
                  <div className="widget-header">
                    <h2 className="widget-title">{footerData.sectionHeader1 }</h2>
                  </div>
                  <div className="widget-content footer-menu">
                    <ul className="f-link list-unstyled mb-0">

                    {footFirstSec!==null?footFirstSec.map((item,index) => (
                      <li key={item.itemOrder}>
                        <a href={"/"+props.match.params.AppId+"/page/"+item.itemid}>{item.itemHeader}</a>
                      </li>
                     )):""}
                     
                  
                    </ul>
                  </div>
                  {/* Widget Content End */}
                </div>
                {/* Widget End */}
              </div>
              {/* Footer Widget End */}
            </div>
            {/* Col End */}
            <div className="col-md-3">
              <div className="footer-widget">
                <div className="widgets">
                  <div className="widget-header">
                    <h2 className="widget-title">{footerData.sectionHeader2 }</h2>
                  </div>
                  <div className="widget-content footer-menu">
                    <ul className="f-link list-unstyled mb-0">
                    {footSecSec!==null?footSecSec.map((item,index) => (
                      <li  key={item.itemOrder}>
                        <a href={"/"+props.match.params.AppId+"/page/"+item.itemid}>{item.itemHeader}</a>
                      </li>
                     )):""}
                     
                    </ul>
                  </div>
                  {/* Widget Content End */}
                </div>
                {/* Widget End */}
              </div>
              {/* Footer Widget End */}
            </div>
            {/* Col End */}
            <div className="col-md-3">
              <div className="footer-widget">
                <div className="widgets">
                  <div className="widget-header">
                    <h2 className="widget-title">{footerData.sectionHeader3 }</h2>
                  </div>
                  <div className="widget-content footer-menu">
                    <ul className="f-link list-unstyled mb-0">
                    {footThirdSec!==null?footThirdSec.map((item,index) => (
                      <li key={item.itemOrder}>
                        <a href={"/"+props.match.params.AppId+"/page/"+item.itemid}>{item.itemHeader}</a>
                      </li>
                     )):""}
                    </ul>
                  </div>
                  {/* Widget Content End */}
                </div>
                {/* Widget End */}
              </div>
              {/* Footer Widget End */}
            </div>
            {/* Col End */}
          </div>
          {/* Row End */}
        </div>
        {/* Container End */}
      </div>
);
}

export default Footer;